<div class="header-container">
  <div class="app-toolbar">
    <div class="brand">
      <img class="broker-logo" [src]="broker().logoHeader" [alt]="broker().logoAlt" />
      <span>Workflow App</span>
    </div>
    <span class="example-spacer"></span>

    <div class="username-container">
      @if (username) {
        <div>
          Hi,
          <a class="username">
            {{ username }}
          </a>
        </div>
      }
      <button
        type="button"
        class="icon-button"
        (click)="expandMenu()"
        aria-label="Open user menu"
      >
        <span class="material-icons">menu</span>
      </button>
    </div>
    <div
      class="user-menu"
      [style.display]="expandUserMenu ? 'flex' : 'none'"
    >
      <button type="button">
        <span class="material-icons" aria-hidden="false" aria-label="Account">
          account_circle
        </span>
        <span>{{ userEmail }}</span>
      </button>
      <button type="button" (click)="logout()">
        <span class="material-icons">logout</span>
        <span>Logout</span>
      </button>
      <hr class="menu-divider" />
      <button type="button">
        <span class="material-icons">tag</span>
        <span>v{{ version }}</span>
      </button>
    </div>
  </div>
</div>
